import type { ElementType } from 'react';
import { CdLink } from '../../atoms/CdLink';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdFeatureCard.module.scss';

export interface CdFeatureCardProps {
  title: string;
  description: string;
  imageSrc?: string;
  /** Empty string = decorative image. */
  imageAlt?: string;
  linkLabel: string;
  href: string;
  /** Element used for the link, e.g. an href-based adapter over React Router's Link. */
  linkAs?: ElementType;
  className?: string;
}

/** Image card with title, copy and a trailing-arrow link ("Build or renovate · Explore permit →"). */
export const CdFeatureCard = ({
  title,
  description,
  imageSrc,
  imageAlt = '',
  linkLabel,
  href,
  linkAs,
  className,
}: CdFeatureCardProps) => {
  return (
    <article className={cx(styles.card, className)}>
      <div className={styles.media}>
        {imageSrc ? (
          <img src={imageSrc} alt={imageAlt} loading="lazy" decoding="async" />
        ) : (
          <div className={styles.placeholder} aria-hidden="true" />
        )}
      </div>
      <div className={styles.body}>
        <CdHeading level={3} size="md">
          {title}
        </CdHeading>
        <CdText tone="secondary">{description}</CdText>
        <CdLink as={linkAs} href={href} withArrow className={styles.link}>
          {linkLabel}
          <span className={styles.srOnly}>: {title}</span>
        </CdLink>
      </div>
    </article>
  );
};
